module.exports = __webpack_public_path__ + "img/event2412_3.ef7bda08.png";